import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class GrupoMaquinaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          grupo_maquina {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombre
                  codigo
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.grupo_maquina.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }
}
